import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import profileReducer from './profileSlice';
import singleOrderReducer from './singleOrderSlice'; // Import the new reducer

// Persist config for profile
const profilePersistConfig = {
    key: 'profile',
    storage,
};

// Persisted reducers
const persistedProfileReducer = persistReducer(profilePersistConfig, profileReducer);

export const store = configureStore({
    reducer: {
        profile: persistedProfileReducer,
        singleOrder: singleOrderReducer, // Add the new reducer to the store
    },
});

export const persistor = persistStore(store);




